import Swal from "sweetalert2";
import i18n from "../i18n";

const swalDialog = (err) => {
  const t = (key) => i18n.t(key);

  Swal.fire({
    html: err?.mess
      ? `
  <div class='error-mess-wrapper'>
    <p class='error-mess-text'>${err?.mess}</p>
  </div>
`
      : `
  <div class='error-mess-wrapper'>
    <p class='error-mess-text'>${t("ERROR_OPS")}</p>
    <p class='error-mess-text'>${t("ERROR_SOMETHING_WENT_WRONG")}</p>
    <p class='error-mess-text'>${t("ERROR_WORKING_ON_IT")}</p>
  </div>
`,
    confirmButtonText: t("CONFIRM"),
    customClass: {
      popup: "p-0",
      confirmButton: "error-popup-btn-style",
      actions: "w-100-percents",
    },
    showConfirmButton: true,
    color: "#000",
    background: "#fff",
  });
};

export default swalDialog;
